var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Lead',{staticClass:"project-lead",attrs:{"project":_vm.item.id,"reference":{ onModel: 'Project', ref: _vm.item.id }}})
}
var staticRenderFns = []

export { render, staticRenderFns }